import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useAuth } from "react-oidc-context";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MaterialTheme from "./components/MaterialTheme";
import LoginPage from "./pages/Login";
import AppRoutes from "./Routes";
import { MeContextProvider } from "./api/me";
import { RegionsContextProvider } from "./api/regions";

const App = () => {
    const auth = useAuth();


    if (auth.error) {
        return <div>Oops... {auth.error.message}</div>;
    }

    if (auth.isAuthenticated) {
        return (
            <>
                <MeContextProvider>
                    <RegionsContextProvider>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <MaterialTheme>
                                <Router>
                                    <AppRoutes />
                                </Router>
                            </MaterialTheme>
                        </LocalizationProvider>
                    </RegionsContextProvider>
                </MeContextProvider>
                <ToastContainer position="top-center" />
            </>
        );
    }

    return <LoginPage />;
};

export default App;
